import { useRouteMatch } from "react-router";
import { useQuery } from "@apollo/client";
import { UserQuery } from "../../../__generated__/UserQuery";
import { USER_QUERY } from "../../../lib/graphql";
import { useAuthenticatedQueryOptions } from "../../../lib/graphql/hooks";

import { DialogProps } from "../../Dialog";
import { InviteClientDialog } from "./invite";
import { ManageClientsDialog } from "./manage";

export interface ClientsAdminDialogProps extends DialogProps {}

export const ClientsAdminDialog = ({
  open,
  ...props
}: ClientsAdminDialogProps) => {
  const listClientsRoute = useRouteMatch({
    path: "/admin/clients",
    exact: true,
  });
  const inviteClientRoute = useRouteMatch("/admin/clients/invite");

  // Get the current user from the UserQuery
  const { skip } = useAuthenticatedQueryOptions();
  const { data } = useQuery<UserQuery>(USER_QUERY, { skip });

  return (
    <>
      <ManageClientsDialog open={open && listClientsRoute != null} {...props} />
      {/* Only show InviteClientDialog for ADMIN users */}
      {data?.user?.type === "ADMIN" && (
        <InviteClientDialog
          open={open && inviteClientRoute != null}
          {...props}
        />
      )}
    </>
  );
};
